import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["questions", "template", "question", "type"]

  connect() {
    this.questionTargets.forEach((question) => this.toggleQuestionFields(question))
  }

  addQuestion(event) {
    event.preventDefault()

    this.questionsTarget.insertAdjacentHTML("beforeend", this.templateTarget.innerHTML)
    this.toggleQuestionFields(this.questionTargets[this.questionTargets.length - 1])
  }

  removeQuestion(event) {
    event.preventDefault()

    event.currentTarget.closest(".survey-question").remove()
  }

  toggleType(event) {
    this.toggleQuestionFields(event.currentTarget.closest(".survey-question"))
  }

  toggleQuestionFields(question) {
    const selectedType = question.querySelector("select").value

    question.querySelectorAll(".survey-type-fields").forEach((section) => {
      const visibleTypes = section.dataset.type.split(" ")
      section.style.display = visibleTypes.includes(selectedType) ? "block" : "none"
    })
  }
}
